<template>
  <g>
    <path
      fill="currentColor"
      d="M16 12V4H17C17.5523 4 18 3.55228 18 3C18 2.44772 17.5523 2 17 2H7C6.44772 2 6 2.44772 6 3C6 3.55228 6.44772 4 7 4H8V12L6 14V16H11.2V22H12.8V16H18V14L16 12ZM9.8 4H14.2V12.666L15.4667 14H8.53333L9.8 12.666V4Z"
    />
  </g>
</template>
